import meta from './meta'
import services from '~/services'
export default {
  mixins: [meta],
  asyncData({ route }) {
    return {
      meta: services.meta.getByPath(route.path),
    }
  },
}
